import { Button } from 'components/buttons';
import { DialogContent, DialogFooter } from 'components/dialog/dialog';
import styled from 'styled-components';

export const DiscardDialogContent = styled(DialogContent).attrs({
  className: 'max-w-md',
})``;

export const DiscardDialogFooter = styled(DialogFooter).attrs({
  className: 'gap-2 sm:gap-2',
})``;

export const CancelDiscardButton = styled(Button).attrs({
  variant: 'secondary',
  className: 'w-full sm:w-auto',
})``;

export const ConfirmDiscardButton = styled(Button).attrs({
  variant: 'destructive',
  className: 'w-full sm:w-auto',
})``;
